<script setup lang="ts">
// 路由导航组件
</script>

<template>
  <div class="app-container">
    <!-- 导航菜单 -->
    <nav class="nav-menu">
      <router-link to="/basic" class="nav-link">基础地图</router-link>
      <router-link to="/advance" class="nav-link">高级功能</router-link>
    </nav>
    
    <!-- 路由视图 -->
    <router-view />
  </div>
</template>

<style scoped>
  .app-container {
    width: 100vw;
    height: 100vh;
    position: relative;
  }

  /* 导航菜单 */
  .nav-menu {
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .nav-link {
    padding: 10px 20px;
    background-color: rgba(80, 80, 80, 0.85);
    backdrop-filter: blur(5px);
    color: white;
    text-decoration: none;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
    text-align: center;
    min-width: 100px;
  }

  .nav-link:hover {
    background: rgba(102, 126, 234, 0.8);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }

  .nav-link.router-link-active {
    background: rgba(102, 126, 234, 0.9);
    border-color: rgba(255, 255, 255, 0.3);
  }
</style>
